import { createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { postRequest } from "../../services/apiCaller/cl_index";
import { trackWithdrawEvent } from "../../service/gtag";

const initialState = {
  withdrawResponse: '',
  loader: false,
  withdrawError: false,
  withdrawSuccess: false,
  withdrawErrMsg: '',

};
const withdrawSlice = createSlice({
  name: "withdraw",
  initialState,
  reducers: {
    setWithdrawError: (state, action) => {
      state.withdrawError = action.payload;
    },
    setWithdrawSuccess: (state, action) => {
      state.withdrawSuccess = action.payload;
    },
    setWithdrawErrMsg: (state, action) => {
      state.withdrawErrMsg = action.payload;
    },
    setWithdrawRes: (state, action) => {
      state.withdrawResponse = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});
export const { setWithdrawRes, setLoader, setWithdrawError, setWithdrawSuccess, setWithdrawErrMsg } =
  withdrawSlice.actions;
export default withdrawSlice.reducer;

export const handleWithdrawAPI = (
  amount,
  email,
  userNumber,
  userId,
  countryCode,
  userType,
  phoneNumber
) => async (dispatch) => {

  function getGtagClientAndSession() {
    const gaCookie = document.cookie.split('; ').find(c => c.startsWith('_ga='));
    const ga4Cookie = document.cookie.split('; ').find(c => c.startsWith('_ga_'));

    let clientId = null;
    let sessionId = null;

    if (gaCookie) {
      const parts = gaCookie.split('.');
      clientId = parts[parts.length - 1];
    }

    // if (ga4Cookie) {
    //   const parts = ga4Cookie.split('.');
    //   sessionId = parts[2]; // timestamp = session start
    // }

    sessionId = Number(Date.now().toString());

    return { clientId, sessionId };
  }

  let { clientId, sessionId } = getGtagClientAndSession();

  dispatch(setLoader(true));
  const url = endpoints?.withdraw;
  const token = getFromLocalStorage("gk");
  const payload = {
    accessToken: token,
    amount: amount,
    callbackUrl: "https://www.google.com/",
    clientType: "mobile",
    email: email,
    mobileOperator: "MPESA",
    msisdn: userNumber,
    paymentOperator: "MPESA",
    userId: userId + "",
    currency: countryCode,
    otp: "1234",
    clientId,
    sessionId
  };

  postRequest(url, payload).then((res) => {
    if (res.status === 200) {
      if (
        res?.data?.statusCode === 400 &&
        res?.data?.result?.data?.message === "INSUFFICIENT_FUNDS"
      ) {
        dispatch(setLoader(false));
        dispatch(setWithdrawError(true));
        dispatch(
          setWithdrawRes("Insufficient funds. Minimum withdrawable amount is KES 50.")
        );
      } else {
        dispatch(setLoader(false));
        dispatch(setWithdrawError(false));
        dispatch(setWithdrawSuccess(true));
        dispatch(setWithdrawRes("Withdraw request placed successfully"));
        trackWithdrawEvent(
          res?.data?.result?.data?.data?.transactionId,
          phoneNumber,
          amount,
          "KES",
          userType,
          "MPESA",
        );
      }
    } else {
      dispatch(setLoader(false));
      dispatch(setWithdrawError(true));
      dispatch(setWithdrawSuccess(false));
      dispatch(setWithdrawRes("Withdraw request failed please try again later"));
    }
  });
};

